import { gql } from '@apollo/client'
import { locationInformationFragment } from 'components/pages/ShiftPage/TruckSectionContent/LocationInformation'
import { truckInformationFragment } from 'components/HeroSection/TruckInformationSectionContent'

export default gql`
  ${locationInformationFragment}
  ${truckInformationFragment}
  query shiftPageQuery($id: Int!) {
    location(id: $id) {
      id
      active
      customerUrl
      lot {
        id
        lotUrl
        latitude
        longitude
      }
      foodImage {
        medium
      }
      ...locationInformationFragment
      truck {
        id
        active
        restaurant {
          id
          active
        }
        ...truckInformationFragment
        image {
          medium
          original
        }
      }
      deadlineAt
    }
    structuredData {
      shiftPage(id: $id)
    }
  }
`
